let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1NHTB")).then(() => parcelRequire('6OpPE'));